import React, { useState } from 'react';
import { validateFunctionalForm } from '../../../utils';

const YardForm = ({ data, title, onSubmit, onCancel }) => {
    const [state, setState] = useState({
        yardName: { name: 'yardName', value: data?.YARD_NAME || '', isRequired: true, error: '' },
        yardCode: { name: 'yardCode', value: data?.YARD_CODE || '', isRequired: true, error: '' },
        location: { name: 'location', value: data?.LOCATION || '', isRequired: false, error: '' },
        capacity: { name: 'capacity', value: data?.CAPACITY || '', isRequired: false, error: '' },
        isActive: { name: 'isActive', value: Boolean(data?.IS_ACTIVE ?? true), isRequired: false },
        note: { name: 'note', value: data?.NOTE || '', isRequired: false, error: '' },
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;
        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: val,
                error: prev[name].isRequired && !val ? 'This field is required' : ''
            }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {
                yardName: state.yardName.value,
                yardCode: state.yardCode.value,
                location: state.location.value,
                capacity: state.capacity.value,
                isActive: state.isActive.value,
                note: state.note.value,
            };
            if (data) model.id = data.ID;
            onSubmit(model);
        }
    };

    const handleCancel = () => {
        onCancel?.();
    };

    return (
        <form onSubmit={handleSubmit}>
            {/* <h4 className="card-title mb-4">{title}</h4> */}
            <div className="row">
                {[
                    { label: 'Yard Name', name: 'yardName', placeholder: 'Enter yard name' },
                    { label: 'Yard Code', name: 'yardCode', placeholder: 'Enter unique yard code' },
                    { label: 'Location', name: 'location', placeholder: 'Enter yard location' },
                    { label: 'Capacity', name: 'capacity', placeholder: 'Enter capacity (if any)' },
                ].map(({ label, name, placeholder }) => (
                    <div className="col-md-6 mb-3" key={name}>
                        <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
                        <input
                            type="text"
                            name={state[name].name}
                            value={state[name].value}
                            onChange={handleChange}
                            placeholder={placeholder}
                            className={state[name].error ? 'form-control is-invalid' : 'form-control'}
                        />
                        {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
                    </div>
                ))}

                <div className="col-md-12 mb-3">
                    <label>Note</label>
                    <textarea
                        name={state.note.name}
                        value={state.note.value}
                        onChange={handleChange}
                        placeholder="Enter any additional note"
                        className="form-control"
                        rows={3}
                    />
                </div>

                <div className="col-md-4 mb-3 form-check ms-2">
                    <input
                        type="checkbox"
                        name={state.isActive.name}
                        checked={state.isActive.value}
                        onChange={handleChange}
                        className="form-check-input"
                        id="isActive"
                    />
                    <label className="form-check-label" htmlFor="isActive">Active</label>
                </div>
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Save</button>
                <button type="button" className="btn btn-danger" onClick={handleCancel}>Cancel</button>
            </div>
        </form>
    );
};

export default YardForm;
